// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var TagCategory;
(function (TagCategory) {
    TagCategory["UNKNOWN"] = "UNKNOWN";
    TagCategory["PAYMENTS"] = "PAYMENTS";
    TagCategory["MEDICAL_HISTORY"] = "MEDICAL_HISTORY";
})(TagCategory || (TagCategory = {}));
export var TagCategory_index;
(function (TagCategory_index) {
    TagCategory_index[TagCategory_index["UNKNOWN"] = 0] = "UNKNOWN";
    TagCategory_index[TagCategory_index["PAYMENTS"] = 1] = "PAYMENTS";
    TagCategory_index[TagCategory_index["MEDICAL_HISTORY"] = 2] = "MEDICAL_HISTORY";
})(TagCategory_index || (TagCategory_index = {}));
